// Authenticated fetch wrapper — automatically attaches JWT token to every request
const authFetch = async (url, options = {}) => {
  const token = localStorage.getItem('polaris_token');
  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
};

export default authFetch;
